export default {
    defaultMessage :'Oops! Something went wrong.',
    defaultMessageId : 'app.error.generic'
}